import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E6AD00",
      "fill-rule": "nonzero",
      d: "M9 0C4.01 0 0 4.01 0 9s4.01 9 9 9 9-4.01 9-9-4.01-9-9-9m0 13.827c-.49 0-.982-.49-.982-.982 0-.49.491-.981.982-.981.49 0 .982.409.982.981 0 .491-.491.982-.982.982m.818-3.763c0 .654-.245 1.145-.818 1.145s-.818-.49-.818-1.145l-.327-4.746c0-.654.49-1.145 1.063-1.145s1.146.49 1.146 1.145z"
    }, null, -1)
  ])))
}
export default { render: render }